import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MediaService } from '@studiobuki/web-core/lib/media';

@Component({
  selector: 'app-section-about-banner',
  templateUrl: './section-about-banner.component.html',
  styleUrls: ['./section-about-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionAboutBannerComponent {
  constructor(public media: MediaService) {}
}
